import { VisitStatisticsScopeSettings } from './types'

export const DEFAULT_VISIT_STATISTICS_SCOPE_SETTINGS: VisitStatisticsScopeSettings = {
  viewMode: 'depth of view',
  usages: [],
  entryPoints: []
}
